import * as styledComponents from 'styled-components';
import { ThemedStyledComponentsModule } from 'styled-components';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

// re-export style-components with extended types
export const {
  default: styled,
  css,
  createGlobalStyle,
  useTheme,
  keyframes,
} = styledComponents as ThemedStyledComponentsModule<BabbelTheme>;
